<template>
    <section id="natureza" class="section py-20 bg-teal-700">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex flex-col lg:flex-row items-center">
                <div class="lg:w-1/2 mb-10 lg:mb-0 lg:pr-10">
                    <h2 class="text-3xl md:text-4xl font-bold text-white mb-6">Natureza Exuberante</h2>
                    <p class="text-lg text-white mb-6">Explore trilhas tranquilas cercadas por paisagens deslumbrantes e descubra espécies botânicas raras e exóticas.</p>
                    <p class="text-lg text-white mb-8">Nosso resort é um refúgio verde, onde o som dos pássaros e o aroma das flores criam uma atmosfera única de paz e conexão com a natureza.</p>
                    <div class="bg-white/20 backdrop-blur-sm p-6 rounded-lg">
                        <div class="flex items-center mb-4">
                            <i class="fas fa-leaf text-white text-xl mr-3"></i>
                            <span class="text-white font-semibold">Trilhas e Jardins Botânicos</span>
                        </div>
                        <p class="text-white">Caminhe por trilhas bem cuidadas, admire plantas tropicais, flores raras e áreas de contemplação ao ar livre.</p>
                    </div>
                </div>

                <!-- Carrossel -->
                <div class="lg:w-1/2">
                    <Swiper :modules="[Grid, Autoplay]" :slides-per-view="2" :grid="{ rows: 2, fill: 'row' }" :space-between="24" :loop="images.length > 4" :autoplay="images.length > 4 ? { delay: 4000, disableOnInteraction: false } : false" class="w-full p-4 bg-transparent">
                        <SwiperSlide v-for="(image, index) in images" :key="index" class="overflow-visible">
                            <img :src="image.src" :alt="image.alt" class="w-full h-72 object-cover rounded-lg shadow-lg transition-transform duration-300 ease-in-out
                                hover:scale-110 hover:z-10 will-change-transform" style="transform-origin: center center;" />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>

            <div class="grid md:grid-cols-3 gap-8 mt-12">
                <div class="text-center">
                    <div class="bg-teal-900 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-tree text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Trilhas Guiadas</h3>
                    <p class="text-gray-200">Explore nossos caminhos através da mata nativa com guias especializados.</p>
                </div>
                <div class="text-center">
                    <div class="bg-teal-900 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-seedling text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Jardins Sensoriais</h3>
                    <p class="text-gray-200">Espécies aromáticas, texturas e cores vibrantes estimulando todos os sentidos.</p>
                </div>
                <div class="text-center">
                    <div class="bg-teal-900 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-moon text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Observação de Estrelas</h3>
                    <p class="text-gray-200">Céu límpido e estrelado, livre da poluição luminosa da cidade.</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Grid } from 'swiper/modules';

const images = [
    { src: new URL('../../assets/images/bg/resort-natureza.jpg', import.meta.url).href, alt: 'Adega de vinhos' },
    { src: new URL('../../assets/images/bg/resort-natureza2.jpg', import.meta.url).href, alt: 'Taças de vinho' },
    { src: new URL('../../assets/images/bg/resort-natureza3.jpg', import.meta.url).href, alt: 'Degustação de vinho' },
    { src: new URL('../../assets/images/bg/resort-natureza4.jpg', import.meta.url).href, alt: 'Garrafas de vinho' },
    { src: new URL('../../assets/images/bg/resort-natureza2.jpg', import.meta.url).href, alt: 'Vista panorâmica' },
    { src: new URL('../../assets/images/bg/resort-natureza.jpg', import.meta.url).href, alt: 'Área de lazer' },
];
</script>
